<div class="card card-default m-3 p-0">
    <div class="card-header">
        <div class="row" id="OfficerFilter">
            <div class="col-6">
                <h3 class="card-title font-cust-blue" style="font-weight:
                    bold;">
                    เลขรับเรื่อง (Ticket)
                </h3>
            </div>
            <div class="col-6">
                <div class="search-box">
                    <div class="right-inner-addon">
                        <i class="fa fa-search"></i>
                        <input type="search" id="Search1" maxlength="13" class="search-txt"
                            placeholder="ค้นหาเลขที่รับเรื่อง..." (change)="onSearch1Change()">
                    </div>
                </div>
            </div>
        </div>
        <div class="row centered-content hidden" id="SuperFilter">
            <div class="col-12 col-md-12 col-lg-12">
                <div class="row m-2">
                    <div class="col-md-3 text-right">
                        ชื่อ
                    </div>
                    <div class="col-md-3">
                        <input type="text" class="form-control" id="SearchFirstName">
                    </div>
                    <div class="col-md-1 text-right">
                        นามสกุล
                    </div>
                    <div class="col-md-3">
                        <input type="text" class="form-control" id="SearchLastName">
                    </div>
                </div>
                <div class="row m-2">
                    <div class="col-md-3 text-right">
                        เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี/เลขพาสปอร์ต
                    </div>
                    <div class="col-md-3">
                        <input type="text" class="form-control" id="SearchIdCard">
                    </div>
                    <div class="col-md-2 text-right sr-only">
                        เลขพาสปอร์ต
                    </div>
                    <div class="col-md-4 sr-only">
                        <input type="text" class="form-control" id="SearchPassport">
                    </div>
                </div>
                <div class="row m-2">
                    <div class="col-12 centered-content">
                        <button class="btn btn-default m-2" (click)="CreateTable1()">ค้นหา</button>
                        <button class="btn btn-default m-2" (click)="CancelSearch()">ยกเลิก</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <table id="Table1" style="width:100%" class="table table-bordered
            table-hover table-responsive-sm result-table display nowrap">
            <thead>
                <tr>
                    <th>เลขที่รับเรื่อง</th>
                    <th>ผู้ติดต่อ</th>
                    <th>ชื่อนิติบุคคล</th>
                    <th>ช่องทางติดต่อ</th>
                    <th>สถานะ</th>
                    <th>วันที่ส่งเอกสาร</th>
                </tr>
            </thead>
            <tbody>
            </tbody>
        </table>
    </div>
</div>

<div class="card card-default m-3 p-0">
    <div class="card-header">
        <div class="row">
            <div class="col-6">
                <h3 class="card-title font-cust-blue" style="font-weight:
                    bold;" id="Table2Title">รายการที่รออนุมัติ / อนุมัติแล้ว</h3>
            </div>
            <div class="col-6">
                <div class="search-box">
                    <div class="right-inner-addon">
                        <i class="fa fa-search"></i>
                        <input type="search" id="Search2" maxlength="13" class="search-txt"
                            placeholder="ค้นหาเลขที่รับเรื่อง..." (change)="onSearch2Change()">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <table id="Table2" style="width:100%" class="table table-bordered
            table-hover table-responsive-sm result-table display nowrap">
            <thead>
                <tr>
                    <th>เลขที่รับเรื่อง</th>
                    <th>ผู้ติดต่อ</th>
                    <th>ชื่อนิติบุคคล</th>
                    <th>ช่องทางติดต่อ</th>
                    <th>สถานะ</th>
                    <th>วันที่ส่งเอกสาร</th>
                </tr>
            </thead>
            <tbody>
            </tbody>
        </table>
    </div>
</div>

<div class="container">
    <div class="modal" id="dlgDetails" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" #dlgContent id="dlgContent" style="width:
                100vw; height: 100vh; position: fixed; top: 0px; left: 0px;
                overflow-y: auto;">
                <div class="modal-header">
                    <nav class="navbar titlebar" style="align-items: center;
                        justify-content: flex-start; width: 100%;">
                        <!-- Brand/logo -->
                        <img src="assets/images/logo.png" width="70" />
                        <!-- Links -->
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <div class="contentheader">สถาบันคุ้มครองเงินฝาก</div>
                                <div class="contentheader2">Deposit Protection Agency
                                </div>
                            </li>
                        </ul>
                        <button type="button" class="close hidden" id="btnCloseDlg" data-dismiss="modal" style="color:
                            white;">X</button>
                    </nav>
                </div>
                <div class="modal-body">
                    <div class="content-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <div style="background-color: #006ED0; width:
                                    fit-content; border-radius: 50px; padding:
                                    20px;" class="mx-auto m-3">
                                    <img src="../../assets/images/home-icon.png" class="mx-auto" width="40">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="row centered-content m-2">
                                    <div class="col-sm-3 col-md-2">
                                        <label>เลขที่รับเรื่อง (Autorun)</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="TicketNo" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="row centered-content m-2">
                                    <div class="col-sm-3 col-md-2">
                                        <label>ประเภทลูกค้า</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="CustomerType" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row hidden" id="divCompany">
                            <div class="col-12">
                                <div class="row centered-content m-2" style="margin-top: 0px !important;">
                                    <div class="col-sm-3 col-md-2">
                                        <label>ชื่อนิติบุคคล</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="CompanyName" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="row centered-content m-2" style="margin-top: 0px !important;">
                                    <div class="col-sm-3 col-md-2">
                                        <label>เลขประจำตัวผู้เสียภาษี</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="RegistrationID" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="row centered-content m-2">
                                    <div class="col-sm-3 col-md-2">
                                        <label>ชื่อผู้รับมอบอำนาจ</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="FirstName1" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="row centered-content m-2">
                                    <div class="col-sm-3 col-md-2">
                                        <label>นามสกุลผู้รับมอบอำนาจ</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="LastName1" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="row centered-content m-2">
                                    <div class="col-sm-3 col-md-2">
                                        <label>เลขบัตรประชาชน</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="CitizenID1" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row hidden" id="divPerson">
                            <div class="col-12">
                                <div class="row centered-content m-2" style="margin-top: 0px !important;">
                                    <div class="col-sm-3 col-md-2">
                                        <label id="IDCardNo">เลขบัตรประชาชน</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="CitizenID2" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="row centered-content m-2">
                                    <div class="col-sm-3 col-md-2">
                                        <label>ชื่อลูกค้า</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="FirstName2" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                                <div class="row centered-content m-2">
                                    <div class="col-sm-3 col-md-2">
                                        <label>นามสกุลลูกค้า</label>
                                    </div>
                                    <div class="col-sm-4 col-md-4">
                                        <input id="LastName2" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" id="divOTP" class="hidden">
                            <div class="col-12">
                                <div class="row centered-content">
                                    <div class="col-12 col-sm-10 col-md-6">
                                        <div class="container">
                                            <div class="row mt-4 mb-4">
                                                <div class="col-12 text-center">
                                                    <h4 class="text-cust-blue">กรอกรหัส OTP</h4>
                                                </div>
                                            </div>
                                            <div class="row mt-4 mb-4">
                                                <div class="col-12 text-center">
                                                    <p>ระบบดำเนินการส่ง OTP SMS ของท่านที่เบอร์มือถือ</p>
                                                    <p>
                                                        <label id="PhoneNo"
                                                            style="color: red; font-size: 1.5rem;">""</label>
                                                    </p>
                                                    <p>กรุณาตรวจสอบ</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 centered-content"
                                                    style="display:flex; vertical-align: bottom;">
                                                    <label style="font-size: 1.1rem;">Reference Code: &nbsp;</label>
                                                    <label style="color: red; font-size: 1.5rem;"
                                                        id="OTPRefCode"></label>
                                                </div>
                                            </div>
                                            <div class="row m-2">
                                                <div class="col-12 centered-content">
                                                    <label style="font-size: 1.25rem;">กรุณากรอกรหัส
                                                        OTP ที่ได้รับ</label>
                                                </div>
                                            </div>
                                            <div class="row justify-content-center">
                                                <div class="col-sm-6 centered-content mt-1">
                                                    <button type="button" class="btn btn-default w-100"
                                                        id="btnRequestOTP" (click)="RequestOTP()">ขอรหัส OTP</button>
                                                </div>
                                            </div>
                                            <div class="row mt-2 justify-content-center">
                                                <div class="col-6">
                                                    <input type="password" id="OTP" class="form-control"
                                                        placeholder="กรอกรหัส OTP"
                                                        style="font-size: 1.1rem; text-align: center;">
                                                </div>
                                            </div>
                                            <div class="row mt-4 mb-4 justify-content-center">
                                                <div class="col-sm-2 centered-content mt-1">
                                                    <button type="button" class="btn btn-default w-100"
                                                        id="btnSubmitOTP" (click)="SubmitOTP()">ยืนยัน</button>
                                                </div>
                                                <div class="col-sm-2 centered-content mt-1">
                                                    <button type="button" class="btn btn-default w-100"
                                                        (click)="BackToHome(true)">ยกเลิก</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        <!-- Document List -->
                        <div class="row centered-content">
                            <div class="col-11 col-md-6" id="divDocList" disabled>
                            </div>
                        </div>
                        <!-- End Document List -->

                        <div class="row centered-content" id="divUpload">
                            <div class="col-md-8 m-4">
                                <div class="upload-btn-wrapper" style="width: 100px; cursor: pointer;">
                                    <!-- <input type="text" id="txtFileName" class="form-control" placeholder="เลือกไฟล์..."> -->
                                    <button class="btn btn-default"><i class="fas
                                        fa-plus"></i>
                                        &nbsp;Upload</button>
                                    <input type="file" id="fileAttach" [accept]="AcceptExtension"
                                        (change)="FileSelect($event.target.files)" />
                                </div>
                                <!-- <button class="btn btn-default" (click)="UploadFile()"><i class="fas
                                        fa-upload"></i>
                                    &nbsp;Upload</button> -->
                            </div>
                        </div>

                        <div class="row centered-content" id="divFiles">
                            <div class="col-md-8">
                                <table id="TableDocs" style="width: 100%;" class="table table-bordered table-hover
                                    table-responsive-sm result-table display
                                    nowrap">
                                    <thead class="hidden">
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>

                        <div class="row centered-content" id="divRemark">
                            <div class="col-sm-3 col-md-2 m-2">
                                <label>หมายเหตุ</label>
                            </div>
                            <div class="col-sm-4 col-md-4 m-2">
                                <input id="Remark" type="text" class="form-control">
                            </div>
                        </div>

                        <div class="row" id="divButtons">
                            <div class="col-12 centered-content">
                                <button type="button" class="btn btn-ok m-4" (click)="UpdateStatus(true)"><span
                                        class="fa fa-check text-white"></span>อนุมัติ</button>
                                <button type="button" class="btn btn-cancel m-4" (click)="UpdateStatus(false)"><span
                                        class="fa fa-times text-white"></span>ไม่อนุมัติ</button>
                            </div>
                        </div>

                        <div class="row hidden" id="divButtonRecreate">
                            <div class="col-12 centered-content">
                                <button type="button" id="btnRecreate" class="btn btn-default m-4"
                                    (click)="RecreateTicket()">อัปโหลดเอกสาร</button>
                            </div>
                        </div>
                    </div>
                    <!--end content-body-->

                    <div class="row">
                        <div class="col-12 centered-content">
                            <button type="button" class="btn btn-primary m-3" (click)="BackToHome(false)">
                                <span class="fa fa-home text-white"></span>กลับสู่หน้าหลัก</button>
                        </div>
                    </div>

                </div>
                <!--end modal-body-->
            </div>
        </div>
    </div>
</div>

<div class="container centered-content">
    <div class="modal" id="dlgFile" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" style="width: 100vw; height: 100vh; position: fixed; top: 0px; left: 0px;
                overflow-y: auto;">
                <div class="modal-header">
                    <h4 class="modal-title" id="FileNameTitle" style="padding-left: 10px;">File</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        style="margin-right: 10px;">
                        <span aria-hidden="true">X</span>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <div class="row">
                        <div class="col-12 centered-content">
                            <iframe width="95%" style="height: 90vh;" id="ViewDocFrame"
                                class="centered-content"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/ticket/ticket-list/ticket-list.component.html